import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-4 shadow-2xl z-50 p-6" style={{ borderColor: '#E78E42' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold mb-2" style={{ color: '#0A3C80' }}>
              Cookie Notice
            </h3>
            <p className="text-gray-600 text-sm">
              We use cookies to enhance your browsing experience and analyze site traffic.
              By clicking "Accept", you consent to our use of cookies.
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleDecline}
              className="px-6 py-2 rounded-lg font-semibold border-2 transition-all hover:shadow-md"
              style={{
                borderColor: '#E78E42',
                color: '#E78E42',
                backgroundColor: 'white'
              }}
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="text-white px-6 py-2 rounded-lg font-semibold shadow-md hover:shadow-lg transition-shadow"
              style={{ backgroundImage: 'linear-gradient(to right, #E78E42, #EAC144)' }}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
